import { render, staticRenderFns } from "./Certificates.vue?vue&type=template&id=8c4d7028&scoped=true"
import script from "./Certificates.vue?vue&type=script&lang=js"
export * from "./Certificates.vue?vue&type=script&lang=js"
import style0 from "./Certificates.vue?vue&type=style&index=0&id=8c4d7028&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8c4d7028",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('8c4d7028')) {
      api.createRecord('8c4d7028', component.options)
    } else {
      api.reload('8c4d7028', component.options)
    }
    module.hot.accept("./Certificates.vue?vue&type=template&id=8c4d7028&scoped=true", function () {
      api.rerender('8c4d7028', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Certificates.vue"
export default component.exports